import L from "leaflet"
import { mapboxToken } from "./mapbox_token"

const ATTRIBUTION =
  '&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'

// Adds the Mapbox Outdoors (default) + Satellite base layers and a layer switcher to `map`.
// Returns { outdoors, satellite }.
export function addMapboxBaseLayers(map) {
  const outdoors = L.tileLayer(
    `https://api.mapbox.com/styles/v1/allroadstaken/clzbxv6l3002l01p66v9eb66s/tiles/256/{z}/{x}/{y}@2x?access_token=${mapboxToken()}`,
    { maxZoom: 19, minZoom: 1, attribution: ATTRIBUTION }
  )

  const satellite = L.tileLayer(
    `https://api.mapbox.com/styles/v1/allroadstaken/clzbzmnad00r601pa2srzfnrj/tiles/256/{z}/{x}/{y}@2x?access_token=${mapboxToken()}`,
    { maxZoom: 19, minZoom: 1, attribution: ATTRIBUTION }
  )

  map.addLayer(outdoors)
  L.control.layers({ Outdoors: outdoors, Satellite: satellite }).addTo(map)

  return { outdoors, satellite }
}
